// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"674":"ab4da30e","892":"89d5ff9a"}[chunkId] + ".js";
};